import { feature as abTestsFeature } from "@theg1group/ab-tests";
import type { FeatureModule } from "@theg1group/feature-kit";
import { feature as fxRatesFeature } from "@theg1group/fx-rates";
import { feature as gamesFeature } from "@theg1group/games-catalog";
import { feature as globalEntitiesFeature } from "@theg1group/global-entities";
import { feature as tagsFeature } from "@theg1group/tags";
import { tableDemoFeature } from "./table-demo-feature";

// Per-domain SPAs own these surfaces now (Phase 4 of the domain taxonomy reorg):
// review.g1.network → entities, reviews, authors, comparisons, answers, faq,
//   pages-mgmt, media-mgmt, taxonomies, moderation, quality
// template.g1.network → templates-mgmt
// news.g1.network → news
// admin.g1.network → network-catalog (operator inventory of *.g1.network hosts)
// console.g1.network keeps cross-domain admin-only surfaces (Platform nav group:
// Global Entities, Niche Fallback, Intelligence, Sites, A/B Tests, Programmatic).
// ab-tests + global-entities are the only feature-package routes left here.
// tags = the cross-domain operator tag vocabulary (Platform group); rows are
// tagged from the per-domain SPAs, the vocabulary is governed here in console.
export const features: readonly FeatureModule[] = [
	abTestsFeature,
	globalEntitiesFeature,
	gamesFeature,
	tagsFeature,
	fxRatesFeature,
	// Shared-table test surface (console.g1.network/table) — Platform group.
	tableDemoFeature,
];
